// @avantia common-code
import { MicroTimer } from '@avantia/client-and-server-utilities';
import { createIsolatedPackageLoggerWithFlags } from '@avantia/logging-and-errors';

export enum HpClaimsDebugFlags {
  None = 0,
  TimeTaken = 2 << 0,
  PageLoadDataHandler = 2 << 1,
  Gtm = 2 << 2,
  Configuration = 2 << 3,
  ValidatorExpressions = 2 << 4,
  ReducerProcessor = 2 << 5,
  All = TimeTaken | PageLoadDataHandler | Gtm | Configuration | ValidatorExpressions | ReducerProcessor
}

const log = createIsolatedPackageLoggerWithFlags<HpClaimsDebugFlags>(
  'HpClaimsDebugFlags',
  HpClaimsDebugFlags.None,
  HpClaimsDebugFlags.All
);

const {
  debug: logDebug,
  info: logInfo,
  notice: logNotice,
  warn: logWarning,
  error: logError,
  critical: logCritical,
  setLogger: setLoggerForQuestionSetWebsite,
  getLogger: getLoggerForQuestionSetWebsite,
  setFlags: setLoggerFlagsForQuestionSetWebsite,
  getFlags: getLoggerFlagsForQuestionSetWebsite
} = log;

export {
  logDebug,
  logInfo,
  logNotice,
  logWarning,
  logError,
  logCritical,
  setLoggerForQuestionSetWebsite,
  getLoggerForQuestionSetWebsite,
  setLoggerFlagsForQuestionSetWebsite,
  getLoggerFlagsForQuestionSetWebsite
};

export function displayTimeTaken(description: string, timer: MicroTimer): void {
  logDebug(`${description}: took ${timer.elapsedTimeAsString()}`, HpClaimsDebugFlags.TimeTaken);
}

export function recordElapsedTime<ResultT>(description: string, action: () => ResultT): ResultT {
  const timer = new MicroTimer();
  const res = action();
  displayTimeTaken(description, timer);
  return res;
}
